export class RoleConst {
    static Admin = 'ADMIN';
    static Back_Office_Manager = 'BACKOFFICEMANAGER';
    static Coordinator = 'SERVICECOORDINATOR';
    static Operator = 'OPERATOR';
    static Beneficiary = 'BENEFICIARY';
}
